import React from 'react'
import { HistogramaIngresoView } from '../../components/histogramas/HistogramaIngresoView'

function HistogramaIngreso () {
  return (
    <div style={{ margin: '2% 0' }}>
      <HistogramaIngresoView />
    </div>

  )
}

export default HistogramaIngreso
